<template>
  <component
    v-if="this.$store.getters.getPageProfile"
    :is="view"
    v-bind="$attrs"
  >
    xxxxxxxxxxxxx
    <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"></slot>
    </template>
  </component>
</template>

<script>
import Default from './Default.vue'
import Nestle from './Nestle.vue'
import Seagull from './Seagull.vue'
export default {
  components: {
    Default,
    Nestle,
    Seagull
  },
  computed: {
    view() {
      if (!this.$store.getters.getPageProfile) return 'Default'
      switch (this.$store.getters.getPageProfile.type) {
        case 'nestle':
          return 'Nestle'
        case 'seagull':
          return 'Seagull'
        default:
          return 'Default'
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
